// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CN2W","colMin":"styles_colMin__2YC6C"};